import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { SalesforceCopySource } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceCopySource),
    disabled: __IS_FABRIC_DPE__,
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        readBehavior: '*'
    }
})
export class SalesforceCopySourceAdapter extends CopySourceAdapter<SalesforceCopySource, Model.SalesforceSource> {
    protected override async _toResource(copySource: SalesforceCopySource): Promise<Model.SalesforceSource> {
        const result: Model.SalesforceSource = this.getCommonCopySourceProperties(copySource, 'SalesforceSource');
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, SalesforceCopySource.READER_QUERY);
        }
        result.readBehavior = ValueAdapter.toResource(copySource, SalesforceCopySource.READ_BEHAVIOR);
        return result;
    }

    protected override async _toModel(
        resource: Model.SalesforceSource,
        copyActivity: CopyActivity
    ): Promise<SalesforceCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            SalesforceCopySource.MODEL,
            resource,
            copyActivity
        ) as SalesforceCopySource;
        if (resource.query) {
            ValueAdapter.toModel(result, SalesforceCopySource.READER_QUERY, resource.query);
            result.mode = 'query';
        }
        ValueAdapter.toModel(result, SalesforceCopySource.READ_BEHAVIOR, resource.readBehavior);
        return result;
    }
}
